"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isFluentTrigger", {
    enumerable: true,
    get: ()=>isFluentTrigger
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function isFluentTrigger(element) {
    return Boolean(element.type.isFluentTriggerComponent);
} //# sourceMappingURL=isFluentTrigger.js.map

//# sourceMappingURL=isFluentTrigger.js.map